import { PickSessionSchema } from "@redotech/redo-fulfillment-wms-common/schema/pick-session";
import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const changePickSessionItemBin = {
  name: "changePickSessionItemBin" as const,
  input: z.object({
    pickSessionId: zExt.objectId(),
    itemIds: z.array(zExt.objectId()).min(1),
    storageLocationId: storageLocationIdFormat.schema,
  }),
  output: z.object({
    success: z.boolean(),
    updatedPickSession: PickSessionSchema.nullish(),
  }),
};
